module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1520-ba9565fc2b5533f7b3200cd362163027.png";